import DataReflectLabel from './DataReflectLabel';

export default DataReflectLabel;